import { Component, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CrossComponentService } from '../../../core/services/cross-component.service';
import { RouterLink } from "@angular/router";


@Component({
  selector: 'app-illustrated-modal',
  imports: [ReactiveFormsModule, RouterLink],
  templateUrl: './illustrated-modal.html',
  styleUrl: './illustrated-modal.scss',
})
export class IllustratedModal {

  illustratedForm!: FormGroup;
  done = signal<boolean>(false);

  constructor(
    private crossComponentService: CrossComponentService,
    private fb: FormBuilder
  ) {
    this.illustratedForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: [undefined],
      company: [''],
      sample_report_type: ['full']
    });
  }


  closeModal() {
    this.crossComponentService.closeIllustratedModal();
  }

  onSubmit() {
    if (this.illustratedForm.invalid) {
      this.illustratedForm.markAllAsTouched();
      return
    }

  }

}
